// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__1T2dh","content":"Layout_content__McLoj","page":"Layout_page__3hF5w"};